import { render, staticRenderFns } from "./PraticheFilters.vue?vue&type=template&id=40941a0b&scoped=true"
import script from "./PraticheFilters.vue?vue&type=script&lang=js"
export * from "./PraticheFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40941a0b",
  null
  
)

export default component.exports